export default __webpack_public_path__ + "static/media/technical_character.bf372a59.svg";